import { LucideIcon } from "../../../common/icon/LucideIcon";
import styles from "../CommonPages.module.css";

export interface PageInfoProps {
  message?: string;
  desc?: string;
}
/**
 * Component to display an error page with details about the error.
 * @author @CorradoSurmanowicz
 * @param {PageInfoProps} props - The properties for the PageInfo component.
 * @param {string} props.message - The error message.
 * @param {string} props.errorDesc - A description of the error.
 *
 * @returns {JSX.Element} The rendered error page component.
 */
export const PageInfo = ({ message = "The requested action is not supported.", desc }: PageInfoProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.image_error}>
        <LucideIcon name="badge-info" />
      </div>
      <div className="flex row-nowrap align-center gap-5">
        <div className={styles.desc}>
          <div className="flex col-nowrap align-center">
            <span style={{ fontWeight: "bold", fontSize: "1.5em" }}>Action Unsupported</span>
            <span style={{ fontWeight: "400", fontSize: "0.75em" }}>{message}</span>
          </div>
          <button
            className="btn btn-primary"
            onClick={() => window.history.back()}
            style={{ width: "min-content", margin: "auto" }}
          >
            Take me back
          </button>
        </div>
      </div>
      {desc && (
        <div className={styles.details}>
          <span className={styles.codeDesc}>Description: {desc}</span>
        </div>
      )}
    </div>
  );
};
